module.exports = __webpack_public_path__ + "img/edge_activites_bike_park.ec8da5c9.svg";